<template>
    <TopNavigation v-if="$route.name !== 'login' && $route.name !== 'pageNotFound'" />
    <RouterView :key="$route.path" />

    <ExtendedToast />
    <ConfirmDialog />
</template>

<script setup lang="ts">
    // Imports
    import ConfirmDialog from 'primevue/confirmdialog';

    import TopNavigation from '@/components/navigation/TopNavigation.vue';
    import ExtendedToast from '@/components/notifications/ExtendedToast.vue';

    document.title = 'Meetspain';
</script>
